
    import { Vue, Prop, Watch, Component } from "vue-property-decorator";
    import { mask } from 'vue-the-mask';
    import { ControladorInterfaz } from '../../../controlador';
    import { Pedido } from '@/__env/lib/Ventas/Pedidos';
    import moment from 'moment';
    import { Utiles } from '@/__env/pluggins/event-bus';
    import { Pago } from '@/__env/lib/Ventas/Pagos';
    import * as Pagos from '@/__env/lib/Ventas/Pagos';
    @Component( {
        name: "Componente",
        props: {},
        components: {}
    } )
    export default class Componente extends Vue
    {

        @Prop()
        public Controlador: ControladorInterfaz;
        public get Pedido() { return this.Controlador.Pedido; }
        public get SubModo() { return this.Controlador.Vista.BarraDerecha.SubModo; }
        public set SubModo( x: string ) { this.Controlador.Vista.BarraDerecha.SubModo = x; }
        public get Modo() { return this.Controlador.Vista.BarraDerecha.Modo; }
        public set Modo( x: string ) { this.Controlador.Vista.BarraDerecha.Modo = x; }
        public get ReservarEspacioDerecha() { return this.Controlador.Vista.BarraDerecha.Anchura.Espacio; }

        public MascaraFecha = '##-##-####';
    public Plataforma: Pagos.Plataformas = null;

        public Cajero: string = null;
        public Fecha: string = null;
        public Operacion: string = null;
        public Banco: {Id: string, Descripcion: string} = null;
        public Importe: string = null;
        public Comprobante: string = null;
        public Recibo: string = null;
        public Empresa: { Descripcion: string, Id: string; } | string = null;

        mounted()
        {
            this.Eventos.push( this.Controlador.Vista.BarraDerecha.onSubModo.subscribe( () =>
            {
                if ( this.SubModo == 'agregar_pago' )
                {
                    this.Controlador.Vista.BarraDerecha.Anchura.Espacio = 400;
                }
            } ) );

            
            this.SubModo = 'agregar_pago';
            this.Iniciar();
        }



        public Cargando: boolean = false;
        protected Eventos: Function[] = [];
        beforeDestroy()
        {
            this.Eventos.forEach( x => x() );
        }


        async Iniciar()
        {

        }


        async Abrir()
        {
            window.open( this.Pedido.DeclaracionBienDeUso );

        }

        public Archivo: File = null;
        public SeleccionarArchivo: boolean = false;
        async AgregarArchivo( x: File )
        {
            this.Archivo = x;
            if ( this.Archivo )
            {
                let e = await Pago.SubirComprobante( this.Archivo );
                if ( e )
                {
                    this.Comprobante = e;
                }
                else
                {
                    this.$EventBus.Notificaciones.Error( 'Error al guardar el archivo' );
                }
            }
        }

        public Validar()
        {
            let e: string[] = [];

            if ( !this.Plataforma ) e.push( 'Ingrese tipo de operación' );
            if ( !this.Empresa ) e.push( 'Ingrese empresa de destino' );
            if ( this.Plataforma && this.Plataforma.esTransferencia )
            {
             //   if ( !this.Cajero ) e.push( 'Ingrese cajero' );
                if ( !this.Operacion ) e.push( 'Ingrese nº operacion' );
                if ( !this.Importe || parseFloat( this.Importe ).isNan() ||  parseFloat( this.Importe ) <= 0 ) e.push( 'Ingrese importe' );
                if ( !this.Fecha) e.push( 'Ingrese fecha' );
            }
            else if ( this.Plataforma && this.Plataforma.esDeposito )
            {
                if ( !this.Cajero ) e.push( 'Ingrese cajero' );
                if ( !this.Operacion ) e.push( 'Ingrese nº operacion' );
                if ( !this.Importe || parseFloat( this.Importe ).isNan() || parseFloat( this.Importe ) <= 0 ) e.push( 'Ingrese importe' );
                if ( !this.Fecha ) e.push( 'Ingrese fecha' );
            }

            else if ( this.Plataforma && this.Plataforma.esContado )
            {
                if ( !this.Importe || parseFloat( this.Importe ).isNan() || parseFloat( this.Importe ) <= 0 ) e.push( 'Ingrese importe' );
                if ( !this.Recibo ) e.push( 'Ingrese nº de recibo' );
            }


            return e;

        }
        public async Guardar()
        {
            let errores = this.Validar();
            if ( errores.hasRows() )
            {
                return await Utiles.Mensajes.Aceptar( 'Se encontraron errores', errores.map( x => `<li>${x}</li>` ).join( '' ) );
            }

            let opt: any = {};
            if ( this.Plataforma && this.Plataforma.esTransferencia )
            {
                opt = {
                    empresa: typeof this.Empresa === 'string' ? this.Empresa : this.Empresa.Id,
                    plataforma: this.Plataforma.Id,
                    importe: this.Importe,
                    banco: this.Banco?.Id,
                    cajero: this.Cajero,
                    operacion: this.Operacion,
                    fecha: moment( this.Fecha, 'DD-MM-YYYY' ).toSQL(),
                    comprobante: this.Comprobante ? this.Comprobante : undefined,

                };
            }
            else if ( this.Plataforma && this.Plataforma.esDeposito )
            {
                opt = {
                    empresa: typeof this.Empresa === 'string' ? this.Empresa : this.Empresa.Id,
                    plataforma: this.Plataforma.Id,
                    importe: this.Importe,
                    banco: this.Banco?.Id,
                    cajero: this.Cajero,
                    operacion: this.Operacion,
                    fecha: moment( this.Fecha, 'DD-MM-YYYY' ).toSQL(),
                    comprobante: this.Comprobante ? this.Comprobante : undefined,

                };
            }

            else if ( this.Plataforma && this.Plataforma.esContado )
            {
                opt = {
                    empresa: typeof this.Empresa === 'string' ? this.Empresa : this.Empresa.Id,
                    plataforma: this.Plataforma.Id,
                    importe: this.Importe,
                    recibo: this.Recibo,

                };
            }


            let crear = await Pago.CrearPago( opt );
            if ( crear )
            {
                let rr = await this.Pedido.AgregarPagos( [crear] );
                if ( rr )
                {
                    window.location.reload();
                } else
                {
                    this.$EventBus.Notificaciones.Error( 'Error al adjuntar el pago' );
                }

            } else
            {
                this.$EventBus.Notificaciones.Error( 'Error al crear el pago' );
            }


        }

        async Cerrar()
        {
            this.Modo = '';
        }

        public Refresh: boolean = false;
        Refrescar()
        {
            this.Refresh = false;
            this.$nextTick( () => this.Refresh = true );
        }
    }
